// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"380":"90b1b2df","504":"1576ebfb"}[chunkId] + ".chunk.js";
};